import React from "react";

import { useNavigate } from "react-router";
import { routes } from "routes";

import SecondaryButton from "components/common/SecondaryButton";
import { TranslationProvider } from "components/useTranslations";

export type NutrientsAdditionButtonProps = {
  translations?: { [key: string]: string } | undefined;
};

const NutrientsAdditionButton: React.FC<
  NutrientsAdditionButtonProps
> = props => {
  const navigateTo = useNavigate();

  return (
    <TranslationProvider translations={props.translations}>
      {t => (
        <SecondaryButton
          name="createNutrient"
          onClick={() => navigateTo(routes.nutrientsCreate)}
        >
          {t`__NUTRIENTS_INITIAL_VIEW_CREATE_BUTTON`}
        </SecondaryButton>
      )}
    </TranslationProvider>
  );
};
export default NutrientsAdditionButton;
